import { AxiosResponse } from 'axios'
import AxiosClient from '@services/api/base'
import { CourseProgress } from '@type/course'
import routes from '@configs/api'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Update Course Progress
 * @param courseId
 * @param lastLectureId
 */
const updateCourseProgress = (
  courseId: string | string[],
  lastLectureId: string
): Promise<CourseProgress> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL = routes.COURSE + courseId + '/progress'
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }
    const data = {
      lastLectureId: lastLectureId,
    }
    AxiosClient.put(URL, data, config)
      .then((res: AxiosResponse<CourseProgress>) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default updateCourseProgress
